import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, InputNumber, notification, Select} from 'antd';

import {addSellLimit} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";

const Option = Select.Option;
const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class SetSellLimitForm extends Component {
  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addSellLimit({...values, dispensaryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}} = this.props;
    return (
      <Card title="Add Sell Limit">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input autoFocus />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Period"
          >
            {getFieldDecorator('period', {
              rules: []
            })(
              <Select>
                <Option key="" value="">Per Order</Option>
                <Option key="daily" value="daily">Daily</Option>
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Limit"
          >
            {getFieldDecorator('value', {
              rules: [{
                required: true,
                message: 'Limit is required'
              }]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Add Sell Limit
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

SetSellLimitForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  addSellLimit: PropTypes.func.isRequired,
  dispensaryId: PropTypes.string,
};

const AddSellLimitPage = Form.create()(SetSellLimitForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
});

const mapDispatchToProps = dispatch => ({
  addSellLimit: payload => (dispatch(addSellLimit(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSellLimitPage);



// WEBPACK FOOTER //
// ./src/SellLimit/AddSellLimitPage.js